import React from "react";
import { Box } from "lucide-react";
import { imgUrl } from "@/lib/api";

// Imagem de produto com placeholder de marca quando não há foto real
export default function ProductImage({ src, alt = "", className = "", label = "Foto em breve" }) {
  const url = imgUrl(src);
  if (url) {
    return (
      <img
        src={url}
        alt={alt}
        loading="lazy"
        className={`w-full h-full object-cover ${className}`}
        data-testid="product-image"
      />
    );
  }
  return (
    <div
      className={`w-full h-full bg-soft-gradient flex flex-col items-center justify-center gap-2 ${className}`}
      data-testid="product-image-placeholder"
    >
      <div className="w-14 h-14 rounded-2xl bg-white shadow-soft flex items-center justify-center">
        <Box className="w-7 h-7 text-pink-300" />
      </div>
      <span className="text-xs font-semibold text-slate-400">{label}</span>
    </div>
  );
}
